// tokenManager.ts - Token管理类
import { RefreshQueueItem } from './types'
import { getTokenByRefreshToken } from '@/apis/login'
import { useUserStore } from '@/store/modules/user'

class TokenManager {
	private accessToken: string = ''
	private refreshToken: string = ''
	private accessTokenExpiry: number = 0
	private isRefreshing: boolean = false
	private refreshQueue: RefreshQueueItem[] = []

	private userStore: any = null

	constructor() {
		this.loadTokens()
	}

	// 从存储中加载token
	private loadTokens(): void {
		if (typeof window !== 'undefined') {
			this.refreshToken = localStorage.getItem('refreshToken') || ''
		}
	}

	// 保存token到存储
	private saveTokens(): void {
		if (typeof window !== 'undefined') {
			localStorage.setItem('refreshToken', this.refreshToken)
		}
	}

	// 设置token
	setTokens(refreshToken: string): void {
		this.refreshToken = refreshToken
		this.saveTokens()
	}

	// 清除token
	clearTokens(): void {
		this.refreshToken = ''
		if (typeof window !== 'undefined') {
			localStorage.removeItem('refreshToken')
		}
	}

	// 获取access token
	getAccessToken(): string {
		return this.accessToken
	}

	// 获取refresh token
	getRefreshToken(): string {
		return this.refreshToken
	}

	// 检查access token是否有效
	isAccessTokenValid(): boolean {
		return !!this.accessToken && Date.now() < this.accessTokenExpiry
	}

	// 刷新token
	async refreshTokens(): Promise<string> {
		// 如果已经在刷新中，将请求加入队列
		if (this.isRefreshing) {
			return new Promise((resolve, reject) => {
				this.refreshQueue.push({ resolve, reject })
			})
		}

		this.isRefreshing = true

		try {
			const refreshToken = this.getRefreshToken()
			if (!refreshToken) {
				throw new Error('No refresh token available')
			}
			this.userStore = useUserStore()

			// 调用刷新token的API
			const { data } = await getTokenByRefreshToken(this.refreshToken)
			// 处理队列中的等待请求
			this.refreshQueue.forEach(({ resolve }) => resolve(data.access_token))
			this.refreshQueue = []

			this.isRefreshing = false
			return data.access_token
		} catch (error) {
			// 刷新失败，清除token并拒绝所有等待的请求
			this.clearTokens()
			this.refreshQueue.forEach(({ reject }) => reject(error))
			this.refreshQueue = []

			this.isRefreshing = false
			throw error
		}
	}
}

export const tokenManager = new TokenManager()
